import { UsersRepository } from '@core/repositories/users.repository';
import { User } from '@shared/interfaces/user';
import { Observable, of } from 'rxjs';

interface ResultUsers {
  id: number;
  attributes: {
    username: string;
    'role-id': string;
    'role-name': string;
  };
}

export class FakeUsersRepository implements UsersRepository {
  dataUsers: Array<ResultUsers> = [
    {
      id: 1,
      attributes: {
        username: 'julalres',
        'role-id': '1',
        'role-name': 'Administrador'
      }
    },
    {
      id: 2,
      attributes: {
        username: 'lforozco',
        'role-id': '2',
        'role-name': 'Consultor'
      }
    },
    {
      id: 3,
      attributes: {
        username: 'aaguirre',
        'role-id': '2',
        'role-name': 'Consultor'
      }
    }
  ];

  users = {
    data: this.dataUsers
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.users);
  }

  add(user: User): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(user: User): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
